module.exports = new __parcel__URL__("Charlie_Display-Light_Italic.bf1a7fdc.woff2").toString();